/**
 * RgpdExportController — bouton « Télécharger mes données (RGPD) »
 * du bloc `#block-export-rgpd` de /profil-utilisateur.html (EPIC-036 / 36.5).
 *
 * Déclenche un fetch streaming sur `GET /rgpd/export`, télécharge le
 * ZIP via `<a download>` (Blob/object URL), affiche un spinner sur le
 * bouton pendant la génération et gère le 423 (génération déjà en cours).
 *
 * Convention CLAUDE.md : aucun HTML inline en JS — l'ancre temporaire
 * `<a download>` est créée puis détachée du DOM, pas un fragment dynamique.
 */

import BaseController from "./base_controller.js";
import { api } from "/js/services/api.js";

export default class RgpdExportController extends BaseController {
  static targets = ["btn"];

  async request(event) {
    event.preventDefault();
    const btn = this._resolveButton(event);
    const originalLabel = btn ? btn.textContent : null;
    if (btn) {
      btn.disabled = true;
      btn.setAttribute("aria-busy", "true");
      btn.textContent = "Génération en cours…";
    }
    try {
      const { blob, filename } = await api.rgpdExport();
      this._downloadBlob(blob, filename);
      this.showSuccess("Téléchargement de votre archive RGPD lancé.");
    } catch (error) {
      const status = error && typeof error.status === "number" ? error.status : 0;
      if (status === 423) {
        this.showError("Génération déjà en cours, réessayez dans quelques minutes.");
      } else {
        const msg = error && error.message
          ? error.message
          : "Erreur lors de la génération de l'export RGPD.";
        this.showError(msg);
      }
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute("aria-busy");
        if (originalLabel !== null) btn.textContent = originalLabel;
      }
    }
  }

  _resolveButton(event) {
    if (this.hasBtnTarget) return this.btnTarget;
    if (event && event.currentTarget instanceof HTMLElement) return event.currentTarget;
    return null;
  }

  _downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  }
}
